import { type RefObject, useEffect } from "react";
import { SALESMAN_SCROLL_OVERLAY } from "../../../common-deprecated/constants";
import { isMaster } from "../../../common-deprecated/settings/utils/commonSettingUtils";
import { sendJsonToSalesman } from "../../../common-deprecated/utils";
import { useCompareV2Selector } from "../redux/store";

/**
 * Syncs the compare v2's scroll state to billboard app
 */
const useOverlayScrollSync = (bodyRef: RefObject<HTMLDivElement>): void => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    useEffect(() => {
        if (!bodyRef.current || !isMaster(commonSettings)) return;

        const onScroll = (): void => {
            sendJsonToSalesman({ action: SALESMAN_SCROLL_OVERLAY, data: bodyRef.current!.scrollTop >> 0 });
        };

        bodyRef.current!.addEventListener("scroll", onScroll);
        return () => bodyRef.current!.removeEventListener("scroll", onScroll);
    }, [bodyRef.current]);
};

export default useOverlayScrollSync;
